export default "__VITE_ASSET__DnCo54px__"